/**
 * @ngdoc overview
 * @name gazelle.components.l10n
 * @description Provides for configuring localization using angular-translate for strings
 *  and angular-moment with moment.js for dates and times.  Moment.js is configured for the
 *  user's preferred locale and time zone so that application developers may simply use these
 *  tools without worrying about determining the user's preferences.
 */
import * as setMomentLocale from './am.locale.run';
import * as setMomentTimeZone from './am.timezone.run';
import * as setLanguage from './l10n.run';

import * as gzL10nLoader from './l10n.factory';
import * as gzL10nMissingTranslation from './l10n.missing.factory';
import * as gzL10nInterpolationService from './l10n.interpolation.service';
import configMaterialDates from './md.dateformat.config';

let module = angular.module('gazelle.components.l10n', [
  'rhino.core',
  'rhino.components.locale',
  'rhino.components.preferences',
  'pascalprecht.translate',
  'angularMoment',
  'ngMaterial',
])
  .config(configureTranslationProvider)
  .config(setLanguage.configSetPreferredLanguage)
  .config(setMomentLocale.configSetMomentLocale)
  .config(setMomentTimeZone.configSetMomentTimeZone)
  .config(configMaterialDates)
  .factory(gzL10nInterpolationService.name, gzL10nInterpolationService.default)
  .factory(gzL10nMissingTranslation.name, gzL10nMissingTranslation.default)
  .factory(gzL10nLoader.name, gzL10nLoader.default)
  // proxy L10N filter to angular-translate filter for legacy code
  .filter('L10N', function(translateFilter) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    return translateFilter;
  }) ;

function configureTranslationProvider($translateProvider) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  $translateProvider.useInterpolation(gzL10nInterpolationService.name);
  if(__DEV__) {
    $translateProvider.useMissingTranslationHandler(gzL10nMissingTranslation.name);
  }

  // Initialize to US English and then update after we receive preferences.
  $translateProvider.preferredLanguage('en-US');
}

// Don't include this while testing because of problems with extra $http calls
/* global __TEST__ */
if(!__TEST__) {
  module
    .run(setMomentLocale.runSetMomentLocale)
    .run(setMomentTimeZone.runSetMomentTimeZone)
    .run(setLanguage.runSetLanguage);
}

export default module.name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/l10n/l10n.module.js